<template>
  <div class="about">
    <div class="container banner">
      <img src="../../static/img/about/banner.png" alt="">
      <div class="content">
        <div class="bread">
          您现在的位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >关于合美</el-breadcrumb-item>
            <el-breadcrumb-item>品牌故事</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="about-title">
          <h3 class="meal-title"><span class="title-line"></span>品牌故事<span class="title-line"></span></h3>
          <p class="sub-title">Brand story</p>
        </div>
        <div class="about-article">
          <img src="../../static/img/about/story1.png" class="imgF" alt="">
          <div class="two-line">
            <div class="line-text">
              常州合美母婴护理有限公司是一家运用现代医学成果与科学护理经验，由三级甲等医院专家团队及专业护理团队组建，为母婴提供一站式产后专业护理与系统健康管理服务的家庭入住式月子中心。<br>
              <br>
              合美月子中心坐落于国家5A级风景区淹城遗址公园内，具有幽雅舒适的修养环境，温馨私密的居住空间；配备顶级母婴专护配套设施；以“阶段式月子模式+管家式贴心服务”为产后母婴提供“多对一”“一对一”的24小时专业呵护，陪伴女性健康精致月子之旅、宝宝健康成长之旅。<br>
              <br>

              合美围绕六大服务、两大中心深耕行业多年，提供包括24h妈妈照护、婴儿专业护理、台式月子膳食、新生儿早早教、产后康复保健、产后纤体塑形的标准化与个性化服务；并集合享誉全国的妇产、心理、营养、保健等学科专家，建立“产后康复”与“科学保健”为一体的健康管理中心，打造骨盆综合修复、腹部综合修复、脊柱综合修复等“纤之韵”品牌项目，让每位孕妈不再错过产后“黄金修复期”，越生越美丽，越生越健康。<br>
              <br>

              选择合美，幸福从这里起航。
            </div>
            <img src="../../static/img/about/story2.png" class="line-img" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "aboutStory"
    }
</script>

<style scoped lang="less">
  .about{
    .banner{
      img{
        width: 100%;
        margin-bottom: 20px;
      }
      .bread{
        margin-bottom: 20px;
        font-size: 12px;
        color:#999999;
        .el-breadcrumb{
          vertical-align: middle;
          display: inline-block;
          span{
            font-size: 12px;
            color:#999999;
          }
        }
      }
      .about-title{
        margin-bottom: 32px;
      }
      .about-article{
        margin-bottom: 80px;
        .imgF{
          width: 100%;
          margin-bottom: 24px;
        }
        .two-line{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .line-text{
            width: 547px;
            color:#666666;
            font-size: 14px;
            line-height: 24px;
            margin-right: 40px;
          }
          .line-img{
            width: 660px;
          }
        }
      }
    }
  }
  .meal-title{
    margin-bottom: 8px;
    text-align: center;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    .title-line{
      width: 65px;
      height: 1px;
      margin:0 30px;
      display: inline-block;
      background-color: #cccccc;
      vertical-align: middle;
    }
  }
  .sub-title{
    color:#b3b3ba;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutStory.vue